define('gigaset_csp/components/product/downloads',[
	"jquery",
	"lodash",
	"cartware/components/_base"
], function(
	$,
	_,
	Component
) {
	return Component.create({
		currentBlock:			null,
		onChangeSimpleCallback:	null,

		constructor: function() {
			this.onChangeSimpleCallback = _.bind(function (e, simple) {
				if (!simple) {
					return;
				}

				this.changeSimple(simple.id);
			}, this);
		},

		$init: function () {
			this.initializeComponent();
		},

		initializeComponent: function () {
			var currentSimple = _.get(window, 'spConfig.__currentSimple');
			var parentId = ('undefined' !== typeof CURRENT_PRODUCT) ? CURRENT_PRODUCT : null;

			$(document).on('product/changeSimple', this.onChangeSimpleCallback);

			if (currentSimple) {
				this.changeSimple(currentSimple.id);
			} else if (parentId) {
				this.changeSimple(parentId);
			}
		},

		changeSimple: function (simple) {
			var downloadBlocks = $('[data-downloads-id]');

			downloadBlocks.each(function (i, e) {
				var block = $(e);

				if (block.data('downloads-id') == simple) {
					block.addClass('active');
				} else {
					block.removeClass('active');
				}
			});
		},

		destructor: function() {
			$(document).off('product/changeSimple', this.onChangeSimpleCallback);
		}
	});
});
